import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TrialDialogService } from '@pyg-services/trial-dialog.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-museums-quote',
  templateUrl: './museums-quote.component.html',
  styleUrls: ['./museums-quote.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MuseumsQuoteComponent {
  private trialDialog = inject(TrialDialogService);

  onOpenDialog() {
    this.trialDialog.openDialog({
      title: 'modal.title.read_story',
      button: 'buttons.read_story',
      place: 'Museums page - top section',
      isMuseum: true,
    });
  }
}
